export interface HeadlineToken {
  symbol: string;
  address: string;
  imageUrl?: string | null;
}

function truncateAddress(address: string): string {
  if (address.length <= 8) return address;
  return `${address.slice(0, 4)}...${address.slice(-4)}`;
}

interface HeadlineItemProps {
  token: HeadlineToken;
  onSelect?: (address: string) => void;
}

export default function HeadlineItem({ token, onSelect }: HeadlineItemProps) {
  const truncated = truncateAddress(token.address);

  return (
    <div
      className={`headline-item ${onSelect ? 'headline-item--clickable' : ''}`}
      role={onSelect ? 'button' : undefined}
      tabIndex={onSelect ? 0 : undefined}
      onClick={() => onSelect?.(token.address)}
      onKeyDown={(e) => onSelect && (e.key === 'Enter' || e.key === ' ') && (e.preventDefault(), onSelect(token.address))}
    >
      <div className="headline-item-thumb">
        {token.imageUrl ? (
          <img src={token.imageUrl} alt="" className="headline-item-img" />
        ) : (
          <span className="headline-item-fallback">
            {token.symbol.slice(0, 2).toUpperCase()}
          </span>
        )}
      </div>
      <span className="headline-item-symbol">{token.symbol}</span>
      <span className="headline-item-address">{truncated}</span>
    </div>
  );
}
